"use client";

import React from "react";
import WhyPhotoBooths from "@/components/organisms/WhyPhotoBooths";
import PhotoboothMachines from "@/components/organisms/PhotoboothMachines";
import MachineOptions from "@/components/organisms/MachineOptions";
import WhereToInstall from "@/components/organisms/WhereToInstall";
import WhySnapBoxVietNam from "@/components/organisms/WhySnapBoxVietNam";
import HighlyCusTomization from "@/components/organisms/HighlyCusTomizable";
import ContactForm from "@/components/organisms/ContactForm.tsx";
import ContactDirectly from "@/components/organisms/ContactDirectly";
import Ebooks from "@/components/organisms/Ebooks";
import Testimonials from "@/components/organisms/Testimonials";
import OurTeams from "@/components/organisms/OurTeam";
import GlobalPartnerships from "@/components/organisms/GlobalPartnerships";
import BrandPartners from "@/components/organisms/BrandPartners";
import DeliveryAndBrands from "@/components/organisms/DeliveryAndBrands";
import EventAndRewards from "@/components/organisms/EventAndRewards";

const Homepage = () => {
  return (
    <>
      <div
        id="home"
        className="min-h-screen bg-gray-50 py-10 px-6 overflow-hidden"
      >
        <div className="max-w-7xl my-0 mx-auto">
          <WhyPhotoBooths />
          <div className="sm:px-6 max-w-5xl mx-auto">
            <WhereToInstall />
          </div>
        </div>
      </div>
      <PhotoboothMachines />
      <MachineOptions />
      <Testimonials />
      <EventAndRewards />
      <div className="bg-primary-light py-12 mb-8">
        <div className="mt-4 sm:px-6 px-8 max-w-5xl mx-auto">
          <WhySnapBoxVietNam />
          <HighlyCusTomization />
        </div>
      </div>

      <BrandPartners />

      <DeliveryAndBrands />
      <GlobalPartnerships />
      <OurTeams />
      <Ebooks />
      <ContactForm />
      <ContactDirectly />
    </>
  );
};

export default Homepage;
